import {
  secureSetItem,
  STORAGE_KEYS,
} from "./secureStorage";
import {
  sanitizeTaskName,
  sanitizeProjectName,
  sanitizeTagName,
  sanitizeClientName,
  sanitizeSprintName,
} from "./inputSanitization";
import {
  setTimeData,
  setProjectData,
  setTaskData,
  setIsRunningData,
  setRunningTaskData,
  setTagData,
  setTagIdData,
  setProjectIdData,
  setSprintNameData,
  setSprintIdData,
  setClientData,
  setClientIdData,
  setIsbillableData,
} from "../../../../../features/timeTrackerData/timeTrackerLogSlice.js";

/**
 * Persists timer start data to localStorage and Redux
 * Centralizes the repetitive pattern of secureSetItem + dispatch
 */
export const persistTimerStartData = ({
  dispatch,
  time,
  taskName,
  projectName,
  projectId,
  tag,
  tagId,
  client,
  clientId,
  sprintName,
  sprintId,
  isBillable,
  runningTaskId = null,
}) => {
  // Sanitize inputs
  const sanitizedTaskName = sanitizeTaskName(taskName);
  const sanitizedProjectName = sanitizeProjectName(projectName);
  const sanitizedTag = tag ? sanitizeTagName(tag) : null;
  const sanitizedClient = client ? sanitizeClientName(client) : null;
  const sanitizedSprintName = sprintName ? sanitizeSprintName(sprintName) : null;

  // Persist to localStorage and Redux
  secureSetItem(STORAGE_KEYS.START_TIME, time);
  dispatch(setTimeData(time));
  
  secureSetItem(STORAGE_KEYS.IS_RUNNING, true);
  dispatch(setIsRunningData(true));
  
  secureSetItem(STORAGE_KEYS.TASK, sanitizedTaskName);
  dispatch(setTaskData(sanitizedTaskName));
  
  secureSetItem(STORAGE_KEYS.PROJECT, sanitizedProjectName);
  dispatch(setProjectData(sanitizedProjectName));
  
  secureSetItem(STORAGE_KEYS.PROJECT_ID, projectId);
  dispatch(setProjectIdData(projectId));
  
  if (sanitizedTag) {
    secureSetItem(STORAGE_KEYS.TAG, sanitizedTag);
    dispatch(setTagData(sanitizedTag));
  }
  
  if (tagId) {
    secureSetItem(STORAGE_KEYS.TAG_ID, tagId);
    dispatch(setTagIdData(tagId));
  }
  
  if (sanitizedClient) {
    secureSetItem(STORAGE_KEYS.CLIENT, sanitizedClient);
    dispatch(setClientData(sanitizedClient));
  }
  
  if (clientId) {
    secureSetItem(STORAGE_KEYS.CLIENT_ID, clientId);
    dispatch(setClientIdData(clientId));
  }
  
  secureSetItem(STORAGE_KEYS.IS_BILLABLE, isBillable);
  dispatch(setIsbillableData(isBillable));

  if (sprintId && sanitizedSprintName) {
    secureSetItem(STORAGE_KEYS.SPRINT_NAME, sanitizedSprintName);
    dispatch(setSprintNameData(sanitizedSprintName));
    secureSetItem(STORAGE_KEYS.SPRINT_ID, sprintId);
    dispatch(setSprintIdData(sprintId));
  }

  if (runningTaskId) {
    secureSetItem(STORAGE_KEYS.RUNNING_TASK, runningTaskId);
    dispatch(setRunningTaskData(runningTaskId));
  }
};
